import { ReturnRequestLineItemDto } from "@babackapp/private-api-client/types";

export type GetLineItemTreatedByLogisticianQuantityParams = {
  lineItem: ReturnRequestLineItemDto;
  withMerchantTreated?: boolean;
};

/**
 * A Line item can be split into different parts in the context of a return request.
 * This function returns the quantity of the line item that has been treated by the logistician.
 * (reject/validate)
 *
 * For example, the order contains 3 white t-shirt
 *
 * ***********************************
 * White t-shirt                   x3
 * ***********************************
 *
 * The customer returns 3 white t-shirt.
 * The logistician has rejected 1 white t-shirt.
 * The logistician has validated 1 white t-shirt.
 * The merchant has rejected 1 white t-shirt.
 *
 * This function would return 2 (item treated by logistician)
 */
export function getLineItemTreatedByLogisticianQuantity({
  lineItem,
  withMerchantTreated,
}: GetLineItemTreatedByLogisticianQuantityParams) {
  const logisticianTreated = lineItem.logistician_informations.reduce(
    (acc, logisticianInformation) => acc + logisticianInformation.quantity,
    0,
  );
  return withMerchantTreated
    ? Math.max(
        logisticianTreated,
        lineItem.merchant_informations.reduce(
          (acc, merchantInformation) => acc + merchantInformation.quantity,
          0,
        ),
      )
    : logisticianTreated;
}
